import React, { useContext } from 'react';
import SalesHistory from '../SalesHistory';
import { SalesHistoryContext } from '../SalesHistoryContext';

const SaleHistoryPage = () => {
  const { salesHistory, salesLoading, refreshSales } = useContext(SalesHistoryContext);
  return <SalesHistory sales={salesHistory} loading={salesLoading} onRefresh={refreshSales} />;
};

export default SaleHistoryPage;
